




import '@adobe/edex/ui/shared/components/footer/footer';
export default {
  components: {
  },
  data: function () {
    return {};
  },
  computed: {
  },
};
